import React, { useState, useEffect, useMemo, forwardRef } from "react";
import PropTypes from "prop-types";

import RadioGroup from "../RadioButton/RadioGroup";
import SelectBody from "./SelectBody";

import { getOptionKey } from "../../utils/select";

const SelectBodyTypeRadioButton = forwardRef(({
  isTranslateLabels,
  options,
  keysDisabled,
  value,
  labels,
  onSelect,
  className,
  withRadio = false,
  searchValue,
  slotsAfterOptions,
}, ref) => {
  const isValueArray = Array.isArray(value);

  const valueNormalized = useMemo(() => (isValueArray ? value : [value]), [isValueArray, value]);
  const optionsNormalized = useMemo(() => {
    if (!options) {
      return [];
    }

    return (!options.length || Array.isArray(options[0])) ? options : [options];
  }, [options]);

  const [valueNormalizedLocal, setValueNormalizedLocal] = useState(valueNormalized);

  // Updates {valueNormalizedLocal} on props {value} change.
  useEffect(() => {
    setValueNormalizedLocal(valueNormalized);
  }, [valueNormalized]);

  if (!options?.length) {
    return null;
  }

  const handleSelect = (optionIndex, optionsGroupIndex, e) => {
    const valueNormalizedNew = valueNormalized.map((value, index) => {
      if (index === optionsGroupIndex) {
        return optionsNormalized[optionsGroupIndex][optionIndex];
      }

      return optionsNormalized[index].find(
        (option) => getOptionKey(option) === getOptionKey(value),
      );
    });

    setValueNormalizedLocal(valueNormalizedNew);

    // if {value} was an array then return as an array of options.
    // if {value} was an object then return as an option.
    onSelect(
      isValueArray ? valueNormalizedNew : valueNormalizedNew[optionsGroupIndex],
      optionIndex,
      optionsGroupIndex,
      e,
    );
  };

  const renderGroup = ({ label, options, indexGroup }) => {
    const selectedId = getOptionKey(valueNormalizedLocal[indexGroup]);

    return (
      <RadioGroup
        key={"radio-group-" + indexGroup}
        isTranslateLabels={isTranslateLabels}
        label={label}
        disabled={keysDisabled}
        groupnName={label}
        value={selectedId}
        options={options}
        onChange={(v, e) => {
          handleSelect(
            options.findIndex((o) => getOptionKey(o) === v),
            indexGroup,
            e,
          );
        }}
        hideRadio={!withRadio}
        searchValue={searchValue}
      />
    );
  };

  return (
    <SelectBody
      ref={ref}
      className={className}
      labels={labels}
      options={options}
      slotsAfterOptions={slotsAfterOptions}
      renderGroup={renderGroup}
    />
  );
});

SelectBodyTypeRadioButton.propTypes = {
  className: PropTypes.string,
  withRadio: PropTypes.bool,
  isTranslateLabels: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.array, PropTypes.object, PropTypes.string, PropTypes.number,
  ]),
  labels: PropTypes.array,
  keysDisabled: PropTypes.array,
  searchValue: PropTypes.string,
  options: PropTypes.array,
  onSelect: PropTypes.func,
};

export default SelectBodyTypeRadioButton;
